// extracted by mini-css-extract-plugin
export default {"root":"scV3oOYSXWolSYsZN6GN","row":"xRfW7TTn3f_lCBxlXX8E","item":"IsewhrvxNPgJxp2dXJ5u","label":"W7HirI0QIxBJrTKhcofL"};